import { msAPI, osAPI, manageAPI } from "./index.js";

export const getNotificationSettings = async () => {
  return (await msAPI.get(`merchant/notification-settings`)).data;
};

export const updateNotificationSettings = async (payload) => {
  return (await msAPI.patch(`merchant/notification-settings`, payload)).data;
};

export const savePaymentCard = async (payload) => {
  return (await msAPI.post(`merchant/merchant-payment-card`, payload)).data;
};

export const saveSellerPaymentCard = async (payload) => {
  return (await msAPI.post(`merchant/seller-payment-card`, payload)).data;
};

export const getPendingOrderCharges = async () => {
  return (await msAPI.get(`merchant/pending-order-charges`)).data;
};

export const getInvoices = async (page, limit, start, end) => {
  return (await msAPI.get(`merchant/invoices`, {
    params: { page, limit, startDate: start, endDate: end }
  })).data;
};

export const getSubscription = async () => {
  return (await msAPI.get(`merchant/subscription`)).data;
};

export const getInvoiceById = async (id) => {
  return (await msAPI.get(`merchant/invoices/${id}`)).data;
};

export const agreeToTerms = async () => {
  return (await msAPI.post(`merchant/tos/agree`)).data;
};

export const emailTerms = async (email) => {
  return (await msAPI.post(`merchant/tos/email`, { email })).data;
};

export const updateAboutUsPage = async (payload, type = "store") => {
  let url = "";
  switch (type) {
    case "store":
      url = `merchant/store/about-us`;
      break;
    case "mothership":
      url = `merchant/mothership/about-us`;
      break;
  }
  return (await msAPI.post(url, payload)).data;
};

export const getAboutUsPage = async (type) => {
  switch (type) {
    case "store":
      return (await msAPI.get(`merchant/store/about-us`)).data;
    case "mothership":
      return (await msAPI.get(`merchant/mothership/about-us`)).data;
  }
};

export const purchaseAddOn = async (addon) => {
  return (await msAPI.post(`merchant/subscription/addon`, { addon: addon })).data;
}

export const upgradeSubscription = async (plan) => {
  return (await msAPI.post(`merchant/subscription/upgrade`, { plan: plan })).data;
};

export const getPricing = async () => {
  return (await msAPI.get(`merchant/subscription-pricing`)).data;
};

export const submitCustomDomain = async (payload) => {
  return (await msAPI.post(`merchant/custom-domain`, payload)).data;
};

export const getSellerCustomDomainJob = async () => {
  return (await msAPI.get(`merchant/seller-custom-domain`)).data;
};

export const getMerchantCustomerJob = async () => {
  return (await msAPI.get(`merchant/merchant-custom-job`)).data;
}

export const createReportSchedule = async (payload) => {
  return (await osAPI.post("merchant/reports/schedule", payload)).data;
};

export const fetchReportSchedules = async () => {
  return (await osAPI.get("merchant/reports/schedules")).data;
};

export const deleteReportScheduleById = async (id) => {
  return (await osAPI.delete(`merchant/reports/schedule/${id}`)).data;
};

export const getDeliveryPolygonRadius = async () => {
  return (await msAPI.get(`merchant/delivery-polygon-radius`)).data;
}

export const generateDeliveryPolygon = async (miles) => {
  return (await msAPI.get(`merchant/delivery-polygon`, { params: { miles } })).data;
}

export const getStore = async () => {
  return (await msAPI.get(`merchant/seller`)).data;
}

export const updateNotificationPreferences = async (payload) => {
  return (await manageAPI.post('push-notification-preferences', payload)).data;
};

export const deactivatePushNotification = async (payload) => {
  return (await manageAPI.post('deactivate-push-notification', payload)).data;
};

/**
 * Get business documents
 * @returns {Promise<{data: Array}>}
 */
export const getBusinessDocuments = async () => {
  return (await manageAPI.get(`merchant/business-documents`)).data;
};

/**
 * Get temporary authenticated URL for a business document
 * @param {string} documentId - The document ID
 * @returns {Promise<{url: string}>}
 */
export const getBusinessDocumentUrl = async (documentId) => {
  return (await manageAPI.get(`merchant/business-document/${documentId}`)).data;
};

/**
 * Get onboard steps for a prospect merchant
 * @returns {Promise<{data: Object}>}
 */
export const getOnboardSteps = async () => {
  return (await manageAPI.get(`merchant/onboard-steps`)).data;
};

/**
 * Mark an onboard step as in progress
 * @param {string} step - The step key to mark as in progress
 * @returns {Promise<{data: Object}>}
 */
export const markOnboardStepInProgress = async (step, markComplete = false) => {
  return (await manageAPI.put(`merchant/onboard-steps/in-progress`, { step, mark_complete: Boolean(markComplete) })).data;
};

/**
 * Create a business document
 * @param {Object} documentData - Document data
 * @param {boolean} documentData.show_on_website - Whether to show on website
 * @param {string} documentData.url - URL of the uploaded file
 * @param {string} documentData.bucket - S3 bucket name
 * @param {string} documentData.filename - Original filename
 * @param {string} documentData.key - S3 key
 * @param {string} documentData.document_type - Type of document
 * @returns {Promise<{document: Object}>}
 */
export const createBusinessDocument = async (documentData) => {
  return (await manageAPI.post(`merchant/business-documents`, {
    document: documentData
  })).data;
};

/**
 * Update special hours (same endpoint as regular hours, but with special_hours key)
 * @param {Array} specialHours - Array of special hour objects
 * @returns {Promise<Object>}
 */
export const updateSpecialHours = async (specialHours) => {
  return (await msAPI.patch(`merchant/store/hours`, { special_hours: specialHours })).data;
};
